import React from 'react';
import UserDropDownMenu from './UserDropDownMenu.jsx';

export default class extends React.Component {
    static propTypes = {
        login: React.PropTypes.string.isRequired,
        accountNum: React.PropTypes.string.isRequired
    };

    constructor(props) {
        super(props);

        this._handleClick = this._handleClick.bind(this);
        this._handleMenuClosing = this._handleMenuClosing.bind(this);

        this.state = {isMenuVisible: false};
    }

    _handleClick(e) {
        e.preventDefault();

        const {isMenuVisible} = this.state;

        this.setState({
            isMenuVisible: !isMenuVisible
        });
    }

    _handleMenuClosing() {
        this.setState({
            isMenuVisible: false
        });
    }

    render() {
        const {login, accountNum} = this.props;
        const {isMenuVisible} = this.state;

        return (
            <li className='user dropdown--menu__container dropdown--menu__container-user'>
                <a href='#' className="dropdown--toggle" onClick={this._handleClick}>{login}</a>
                {isMenuVisible && <UserDropDownMenu onClosing={this._handleMenuClosing} accountNum={accountNum} />}
            </li>
        );
    }
}



// WEBPACK FOOTER //
// ./js/sport-betting/components/header/LoginButton.jsx